import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { PackagePromotionDialogData } from './package-promotion-dialog.data';

@Component({
    selector : 'package-promotion-dialog',
    template: require('./package-promotion-dialog.component.html'),
    styles: [require('./package-promotion-dialog.component.scss')]
})
export class PackagePromotionDialogComponent {
    public selectedProject: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: PackagePromotionDialogData) {
    }

    public onSelectProject(newValue: any) {
        this.selectedProject = newValue;
        this.data.targetProjectId = newValue.projectId;
        this.data.suggestedVersion = newValue.suggestedPackageName;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/package-promotion-dialog/package-promotion-dialog.component.ts